import Component from '../core/Component'
import { query, queryAll } from '../utils/dom'
import { getScroll } from '../services/Viewport'


export default class ImageMagnifier extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            image: null
        }

        this.images = queryAll('[data-magnifier]')
        this.currentImage = null
        this.timer = null

        document.body.appendChild(this.element)
    }

    prepare() {
        this.images.forEach(image => {
            image.addEventListener('mouseenter', () => this.show(image))
            image.addEventListener('mouseleave', () => this.hide())
        })
    }

    show(image) {
        clearTimeout(this.timer)

        let imageRect = image.getBoundingClientRect()
        const scroll = getScroll()

        imageRect = {
            width: imageRect.width,
            height: imageRect.height,
            y: imageRect.top,
            x: imageRect.left,
            documentY: scroll.y + imageRect.top,
            documentX: scroll.x + imageRect.left
        }

        this.ref.image.src = image.dataset.magnifier

        if (!this.is('is-visible')) {
            this.element.classList.add('is-visible')
            this.element.offsetWidth
            this.element.classList.add('is-active')
        }

        this.element.style.top = `${imageRect.documentY + imageRect.height/2}px`
        this.element.style.left = `${imageRect.documentX + imageRect.width/2}px`
    }

    hide() {
        this.timer = setTimeout(() => {
            this.element.classList.remove('is-visible')
            this.element.classList.remove('is-active')
            this.currentImage = null
        }, 400);
    }
}


// WEBPACK FOOTER //
// ./components/ImageMagnifier.js